var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRevolut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Revolut",
    transform: "translate(-522 -786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5221",
    "data-name": "Rectangle 5221",
    width: 112,
    height: 56,
    transform: "translate(522 786)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Revolut-Logo.wine",
    d: "M58.3,7.361a8.469,8.469,0,0,0-10.888,0A6.793,6.793,0,0,0,45.129,12.8a6.892,6.892,0,0,0,2.285,5.464,8.562,8.562,0,0,0,10.888,0A6.821,6.821,0,0,0,60.615,12.8,6.727,6.727,0,0,0,58.3,7.361Zm-8.314,8.408a3.931,3.931,0,0,1-1.2-2.972,3.815,3.815,0,0,1,1.2-2.944,3.964,3.964,0,0,1,2.855-1.132,4.035,4.035,0,0,1,2.885,1.132A3.752,3.752,0,0,1,56.957,12.8a3.84,3.84,0,0,1-1.229,2.972,4.127,4.127,0,0,1-2.885,1.1A4.061,4.061,0,0,1,49.987,15.769Zm16.031,4.048V.39h-3.6V19.817ZM77.639,5.775v7.751a2.965,2.965,0,1,1-5.923,0V5.775H68.109v8.346c0,3.233,2.057,6.092,6.571,6.092h.028c4.486,0,6.54-2.922,6.54-6.092V5.775Zm-36.343,0-3.6,9.512L34.1,5.775H30.267l5.745,14.042h3.373L45.128,5.775ZM30.286,12.4a6.952,6.952,0,0,0-1.943-5.039,6.594,6.594,0,0,0-4.971-1.981,7.443,7.443,0,0,0-5.316,2.095A7.064,7.064,0,0,0,15.914,12.8a7.213,7.213,0,0,0,2.114,5.35A7.129,7.129,0,0,0,23.2,20.214a6.847,6.847,0,0,0,6.656-4.105L27.172,14.58a4.178,4.178,0,0,1-3.914,2.576,3.714,3.714,0,0,1-3.886-3.51H30.285V12.4Zm-7.03-4.3a3.5,3.5,0,0,1,3.714,2.944h-7.6A4.128,4.128,0,0,1,23.256,8.1Zm-7.341,11.72-4.83-8.379c3.056-1.1,4.571-3.029,4.571-5.832C15.658,2.18,12.913,0,8.542,0H0V19.817H3.772v-8.04h3.2l4.628,8.04ZM8.542,3.283c2.229,0,3.344.877,3.344,2.6s-1.116,2.6-3.344,2.6H3.772V3.283Zm78.809,16.93a4.179,4.179,0,0,1-4.2-4.162V1.982h3.6v3.8h3.087V8.668H86.754v7.154a1.225,1.225,0,0,0,1.232,1.22h1.854v3.171Z",
    transform: "translate(533.083 804.083)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRevolut);
export default __webpack_public_path__ + "static/media/Logo_Revolut.96b63785522912474b8b454d28d46fa3.svg";
export { ForwardRef as ReactComponent };